import { useEffect, useState } from 'react';
import getIntersectionObserverCb from './getIntersectionObserverCb';
const useInViewport = (element, rootMargin = '0px') => {
    const [inViewport, setInViewport] = useState(false);
    useEffect(() => {
        const { current } = element;
        const cb = getIntersectionObserverCb(setInViewport);
        const observer = new IntersectionObserver(cb, { rootMargin });
        current && observer.observe(current);
        return () => {
            /* istanbul ignore else */
            if (current) {
                observer.unobserve(current);
            }
        };
    }, [element, rootMargin]);
    return inViewport;
};
export default useInViewport;
//# sourceMappingURL=index.js.map